import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import {
	Button,
	ButtonToolbar,
	ControlLabel,
	FormControl,
	FormGroup,
	Modal,
	Panel,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { SET_E_WALLET } from 'actions/const';

import { IS_EMPTY_STRING, IS_UNDEFINED, IS_VALID, RETRIEVE_ALL } from 'utils';

import saveTrail from '../../utils/saveTrail';
import CrudComponent from './../zynappse-crud';
import EWalletSchema from './EWallet.js';
import FormContainer from './FormContainer';

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class EWallet extends Component {
	constructor(props) {
		super(props);

		this.refreshTableReference;

		this.refreshTable = this.refreshTable.bind(this);
		this.renderModalButton = this.renderModalButton.bind(this);
		this.saveData = this.saveData.bind(this);
		this.deleteData = this.deleteData.bind(this);
		this.accessible = this.accessible.bind(this);
		this.getRelation = this.getRelation.bind(this);
	}

	refreshTable() {
		if (
			IS_VALID(this.refreshTableReference) &&
			typeof this.refreshTableReference === 'function'
		) {
			this.refreshTableReference();
		}
	}

	renderModalButton() {
		let { EWallet, actions } = this.props;

		let { formType, isLoadingAction } = EWallet;

		let buttons = [];

		let button = (name, callback) => (
			<Button bsStyle="primary" onClick={() => callback()} disabled={isLoadingAction}>
				{isLoadingAction ? (
					<span>
						<i className="fa fa-spinner fa-spin" style={{ color: 'white' }}></i>&nbsp;
					</span>
				) : (
					''
				)}
				{name}
			</Button>
		);

		let buttonClose = (
			<Button
				disabled={isLoadingAction}
				onClick={() => {
					if (!isLoadingAction) {
						actions.setValue({
							showModal: false,
						});
					}
				}}
			>
				CLOSE
			</Button>
		);

		switch (formType.toUpperCase()) {
			case 'CREATE':
				buttons.push(button('CREATE', this.saveData), buttonClose);
				break;
			case 'UPDATE':
				buttons.push(button('UPDATE', this.saveData), buttonClose);
				break;
				break;
			case 'DELETE':
				buttons.push(button('DELETE', this.deleteData), buttonClose);
				break;
			default:
				buttons.push(buttonClose);
				break;
		}
		return buttons;
	}

	async saveData() {
		let { EWallet, actions } = this.props;

		let {
			selectedData,
			formType,
			formId,

			image,
			imageSize,
			walletCode,
			walletName,
			totalBalanceKey,
			earnedTodayKey,
			balanceKey,
			sort,
			isShowDuration,
			durationStartDate,
			durationEndDate,
			isShowWallet,
			isHideZeroBal,
			isShowRedeem,
			isShowEarnedToday,
			isShowTotalBal,
			isShowHistory,

			cardType,
			excludedCardType,
			specificUser,
			blacklistedUser,
			deviceType,
		} = EWallet;

		if (!IS_VALID(walletName) && !IS_VALID(walletName.trim())) {
			toast.error('Wallet Name is required.');
		} else if (!IS_VALID(totalBalanceKey) && !IS_VALID(totalBalanceKey.trim())) {
			toast.error('Total Balance Key is required.');
		} else if (!IS_VALID(earnedTodayKey) && !IS_VALID(earnedTodayKey.trim())) {
			toast.error('Earned today Key is required.');
		} else if (!IS_VALID(balanceKey) && !IS_VALID(balanceKey.trim())) {
			toast.error('Balance Key is required.');
		} else if (!IS_VALID(sort)) {
			toast.error('Sort is required.');
		} else if (
			isShowDuration &&
			IS_VALID(durationStartDate) &&
			!moment(durationStartDate, 'MMM DD, YYYY hh:mm A', true).isValid()
		) {
			toast.error('Please select a valid Duration Start Date');
		} else if (
			isShowDuration &&
			IS_VALID(durationEndDate) &&
			!moment(durationEndDate, 'MMM DD, YYYY hh:mm A', true).isValid()
		) {
			toast.error('Please select a valid Duration End Date');
		} else if (
			isShowDuration &&
			IS_VALID(durationStartDate) &&
			IS_VALID(durationEndDate) &&
			moment(durationEndDate, 'MMM DD, YYYY hh:mm A', true).isBefore(
				moment(durationStartDate, 'MMM DD, YYYY hh:mm A', true)
			)
		) {
			toast.error('Duration End Date should be greater than Duration Start Date.');
		} else if (
			isShowDuration &&
			IS_VALID(durationStartDate) &&
			IS_VALID(durationEndDate) &&
			moment(durationEndDate, 'MMM DD, YYYY hh:mm A', true).isSame(
				moment(durationStartDate, 'MMM DD, YYYY hh:mm A', true)
			)
		) {
			toast.error('Duration Start Date and Duration End Date should not be the same.');
		} else if (
			(!IS_VALID(durationStartDate) && IS_VALID(durationEndDate)) ||
			(IS_VALID(durationStartDate) && !IS_VALID(durationEndDate))
		) {
			toast.error('Please select a Duration Start and End Date.');
		} else {
			actions.setValue({
				isLoadingAction: true,
			});

			let fd = new FormData();

			fd.append('userId', Parse.User.current().id);
			fd.append('walletCode', walletCode);
			fd.append('walletName', walletName);
			fd.append('totalBalanceKey', totalBalanceKey);
			fd.append('earnedTodayKey', earnedTodayKey);
			fd.append('balanceKey', balanceKey);
			fd.append('sort', sort);

			if (IS_VALID(image)) {
				if (image.preview) {
					fd.append('image', image);
				} else {
					fd.append('isImageChange', false);
				}
			}

			fd.append('imageSize', imageSize.value);
			fd.append('isShowDuration', isShowDuration);

			if (isShowDuration && IS_VALID(durationStartDate) && IS_VALID(durationEndDate)) {
				fd.append(
					'durationStartDate',
					moment(durationStartDate, 'MMM DD, YYYY hh:mm A', true).format()
				);

				fd.append(
					'durationEndDate',
					moment(durationEndDate, 'MMM DD, YYYY hh:mm A', true).format()
				);
			}

			fd.append('isShowWallet', isShowWallet);
			fd.append('isHideZeroBal', isHideZeroBal);
			fd.append('isShowRedeem', isShowRedeem);
			fd.append('isShowEarnedToday', isShowEarnedToday);
			fd.append('isShowTotalBal', isShowTotalBal);
			fd.append('isShowHistory', isShowHistory);

			if (IS_VALID(cardType) && Array.isArray(cardType) && specificUser.length === 0) {
				for (let index in cardType) {
					fd.append(`cardTypeIdArray[${index}]`, cardType[index].value || '');
				}
			}

			if (IS_VALID(excludedCardType) && Array.isArray(excludedCardType)) {
				for (let index in excludedCardType) {
					fd.append(
						`excludedCardTypeIdArray[${index}]`,
						excludedCardType[index].value || ''
					);
				}
			}

			if (IS_VALID(specificUser) && Array.isArray(specificUser) && cardType.length === 0) {
				for (let index in specificUser) {
					fd.append(`specificUserIdArray[${index}]`, specificUser[index].value || '');
				}
			}
			if (IS_VALID(blacklistedUser) && Array.isArray(blacklistedUser)) {
				for (let index in blacklistedUser) {
					fd.append(
						`blacklistedUserIdArray[${index}]`,
						blacklistedUser[index].value || ''
					);
				}
			}

			if (IS_VALID(deviceType)) {
				fd.append(`deviceType`, deviceType.value);
			}

			let httpMethod = 'post',
				api_url = `${WEB_PATH}/EWallet`;

			if (
				!IS_EMPTY_STRING(formType) &&
				formType.toUpperCase() === 'UPDATE' &&
				!IS_EMPTY_STRING(formId)
			) {
				httpMethod = 'put';
				api_url = `${api_url}/${formId}`;
			}

			axios[httpMethod](api_url, fd)
				.then((res) => {
					let { data, changesObject } = res.data;

					actions.setValue({
						isLoadingAction: false,
						showModal: false,
					});

					this.refreshTable();

					saveTrail(formType.toUpperCase(), changesObject);
				})
				.catch((err) => {
					console.log('saveData error');
					console.log(err);

					actions.setValue({
						isLoadingAction: false,
						showModal: false,
					});

					this.refreshTable();
				});
		}
	}

	deleteData() {
		let { EWallet, actions } = this.props;

		let { selectedData } = EWallet;

		actions.setValue({ isLoadingAction: true });

		selectedData.set('isDeleted', true);

		selectedData
			.save()
			.then((data) => {
				actions.setValue({
					isLoadingAction: false,
					showModal: false,
				});

				this.refreshTable();

				saveTrail('DELETE', {
					objectId: selectedData.id,
					walletCode: selectedData.get('walletCode') || '',
					walletName: selectedData.get('walletName') || '',
					totalBalanceKey: selectedData.get('totalBalanceKey') || '',
					earnedTodayKey: selectedData.get('earnedTodayKey') || '',
					balanceKey: selectedData.get('balanceKey') || '',
					sort: selectedData.get('sort') || 0,
				});
			})
			.catch((err) => {
				console.log('deleteData error');
				console.log(err);

				actions.setValue({
					isLoadingAction: false,
					showModal: false,
				});

				this.refreshTable();
			});
	}

	accessible(actionType) {
		let { access } = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
				index = access
					.map((module) => module.route.toUpperCase())
					.indexOf(currentPath.toUpperCase()),
				actions = [];

			if (access[index]) {
				actions = access[index].actions;
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
				return 'none';
			}
		} else {
			return 'none';
		}
	}

	loadOptions(input, cb, className, columnName, sortColumn = columnName) {
		let query,
			objectItem = (item) => {
				let json = {
					label: item.get(columnName),
					value: item.id,
				};

				if (className === 'VoucherValidityType' || className === 'VoucherType') {
					json.shortName = item.get('shortName');
				}

				return json;
			};

		if (className === 'MemberDetail') {
			let query1 = new Parse.Query(className),
				query2 = new Parse.Query(className);

			query1.matches('memberId', input, 'i');

			query2.matches('name', input, 'i');

			query = Parse.Query.or(query1, query2);

			query.exists('memberId');
			query.notEqualTo('memberId', '');

			query.ascending('name');

			objectItem = (item) => {
				return {
					label: `${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
						IS_VALID(item.get('name')) ? item.get('name') : ''
					}`,
					value: item.id,
				};
			};
		} else if (className === 'User') {
			query = new Parse.Query(Parse.User);

			query.equalTo('userType', 'MERCHANT');
			query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
			query.ascending(sortColumn);
		} else if (className === 'CampaignCategory') {
			query = new Parse.Query(className);

			query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
			query.ascending(sortColumn);

			objectItem = (item) => {
				let json = {
					label: item.get(columnName),
					value: item.id,
				};

				// let additionalColumns = [
				//   "descriptions",
				// ];

				// for (let column of additionalColumns) {
				//   if (IS_VALID(item.get(column))) {

				//     json[column] = item.get(column);
				//   }
				// }

				return json;
			};
		} else {
			query = new Parse.Query(className);

			query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
			query.ascending(sortColumn);
		}

		query.limit(20);

		query
			.find()
			.then((data) => {
				return data.map(objectItem);
			})
			.then((data) => {
				cb(null, { options: data });
			})
			.catch((err) => {
				console.log('Load Select Options error: ', err.message);
			});
	}

	getRelation() {
		let { actions, EWallet } = this.props;

		let { formType, selectedData } = EWallet;

		let cardTypeRelationQuery = selectedData.relation('cardType').query();
		let excludedCardTypeRelationQuery = selectedData.relation('excludedCardType').query();
		let specificUser = selectedData.relation('specificUser').query();
		let blacklistedUser = selectedData.relation('blacklistedUser').query();

		cardTypeRelationQuery.ascending('name');
		excludedCardTypeRelationQuery.ascending('name');
		specificUser.ascending('name');
		blacklistedUser.ascending('name');

		return Promise.all([
			cardTypeRelationQuery.find(),
			excludedCardTypeRelationQuery.find(),
			RETRIEVE_ALL(specificUser),
			RETRIEVE_ALL(blacklistedUser),
		]);
	}

	render() {
		let { EWallet, accessjson, actions } = this.props;

		let {
			showModal,
			isLoadingAction,

			selectedData,
			formType,
			formTitle,

			imageSizeOptions,
		} = EWallet;

		let crudProps = {
			schema: EWalletSchema,
			access: accessjson.access,
			moduleQuery: [{ method: 'ascending', column: 'sort' }],
			saveTrail: saveTrail,
			refreshTable: (refreshTable) => {
				this.refreshTableReference = refreshTable;
			},
			customView: (obj) => {
				actions.setValue({
					showModal: true,
					formType: 'VIEW',
					formTitle: 'VIEW E-WALLET',
					formId: obj.id,
					selectedData: obj,
				});
			},
			customCreate: () => {
				actions.setValue({
					showModal: true,
					formType: 'CREATE',
					formTitle: 'CREATE E-WALLET',
					formId: '',
					selectedData: null,
				});
			},
			customUpdate: (obj) => {
				let stateToUpdate = {
					showModal: true,
					formType: 'UPDATE',
					formTitle: 'UPDATE E-WALLET',
					formId: obj.id,
					selectedData: obj,
				};

				if (IS_VALID(obj.get('image'))) {
					stateToUpdate.image = {
						url: obj.get('image').url(),
						name: obj.get('image').name(),
					};
				}

				if (IS_VALID(obj.get('imageSize'))) {
					switch (obj.get('imageSize')) {
						case 'S':
							stateToUpdate.imageSize = imageSizeOptions[0];
							break;
						case 'L':
							stateToUpdate.imageSize = imageSizeOptions[1];
							break;
						default:
							stateToUpdate.imageSize = imageSizeOptions[0];
							break;
					}
				}

				if (IS_VALID(obj.get('walletCode'))) {
					stateToUpdate.walletCode = obj.get('walletCode');
				}

				if (IS_VALID(obj.get('walletName'))) {
					stateToUpdate.walletName = obj.get('walletName');
				}

				if (IS_VALID(obj.get('totalBalanceKey'))) {
					stateToUpdate.totalBalanceKey = obj.get('totalBalanceKey');
				}

				if (IS_VALID(obj.get('earnedTodayKey'))) {
					stateToUpdate.earnedTodayKey = obj.get('earnedTodayKey');
				}

				if (IS_VALID(obj.get('balanceKey'))) {
					stateToUpdate.balanceKey = obj.get('balanceKey');
				}

				if (IS_VALID(obj.get('sort'))) {
					stateToUpdate.sort = obj.get('sort');
				}

				stateToUpdate.isShowDuration = obj.get('isShowDuration') || false;

				if (IS_VALID(obj.get('durationStartDate'))) {
					stateToUpdate.durationStartDate = moment(obj.get('durationStartDate'));
				}

				if (IS_VALID(obj.get('durationEndDate'))) {
					stateToUpdate.durationEndDate = moment(obj.get('durationEndDate'));
				}

				stateToUpdate.isShowWallet = obj.get('isShowWallet') || false;
				stateToUpdate.isHideZeroBal = obj.get('isHideZeroBal') || false;
				stateToUpdate.isShowRedeem = obj.get('isShowRedeem') || false;
				stateToUpdate.isShowEarnedToday = obj.get('isShowEarnedToday') || false;
				stateToUpdate.isShowTotalBal = obj.get('isShowTotalBal') || false;
				stateToUpdate.isShowHistory = obj.get('isShowHistory') || false;

				if (IS_VALID(obj.get('deviceType'))) {
					stateToUpdate.deviceType = {
						label: obj.get('deviceType'),
						value: obj.get('deviceType'),
					};
				}

				actions.setValue(stateToUpdate);
			},
			customDelete: (obj) => {
				actions.setValue({
					showModal: true,
					formType: 'DELETE',
					formTitle: 'DELETE  E-WALLET',
					formId: obj.id,
					selectedData: obj,
				});
			},
			customItems: [
				{
					columnName: 'sort',
					render: ({ value, column, getTableData, object }) => {
						let renderValue = '';

						if (IS_VALID(object.get('sort'))) {
							renderValue = object.get('sort');
						}

						return renderValue;
					},
				},
			],
		};

		let formContainerProps = {
			actions,

			selectedData,
			formType,

			loadOptions: this.loadOptions,
			getRelation: this.getRelation,
		};

		return (
			<div>
				<Panel>
					<Panel.Heading
						style={{
							backgroundColor: '#D1282F',
							color: 'white',
						}}
					>
						<h4>E-wallet</h4>
					</Panel.Heading>
					<Panel.Body>
						<CrudComponent {...crudProps} />
					</Panel.Body>
				</Panel>
				<Modal
					bsSize={null}
					show={showModal}
					onHide={() => {
						if (!isLoadingAction) {
							actions.setValue({
								showModal: false,
							});
						}
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormContainer {...formContainerProps} />
					</Modal.Body>
					<Modal.Footer>{this.renderModalButton()}</Modal.Footer>
				</Modal>
				<ToastContainer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	var { accessjson, EWallet } = state;
	return {
		accessjson,
		EWallet,
	};
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: (keyValueObj, actionType = SET_E_WALLET) =>
			generics.setValue(actionType, keyValueObj),
	};

	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(EWallet);



// WEBPACK FOOTER //
// ./components/EWallet/index.js